export class ResultInfoDto {
  success: boolean;
  messages: string[];
}

export class ResultInfoGenericDto<T> extends ResultInfoDto {
  data: T;
}
